<template>
  <div
    class="car"
    @mouseover="isMouseOver = true"
    @mouseleave="isMouseOver = false"
    @click="$emit('select', car.value)"
  >
    <div class="car__image-wrapper">
      <label
        :for="id"
        :class="[
          'h3',
          'car__label',
          {'car__label_blank' : !car.images.hover && !car.images.default}
        ]"
        v-html="car.label"
      />
      <transition name="fade">
        <Blank v-if="!car.images.hover && !car.images.default" />
        <img
          v-else
          :id="id"
          :key="key"
          :src="imgSrc"
          :alt="`Model ${car.label}`"
          class="car__image"
        >
      </transition>
    </div>
  </div>
</template>

<script>
  import Blank from '@/assets/img/icons/blank.svg?inline'
  import { get } from 'lodash'

  export default {
    name: 'Car',

    components: {
      Blank
    },

    props: {
      car: {
        type: Object,
        required: true,
        validator (car) {
          return 'images' in car &&
            'default' in car.images &&
            'hover' in car.images &&
            'label' in car &&
            'value' in car
        }
      }
    },
    data () {
      return {
        isMouseOver: false
      }
    },
    computed: {
      id () {
        return `car-model-${this.car.value}`
      },
      key () {
        return `car-model-${this.imgSrc}`
      },
      imgSrc () {
        return this.isMouseOver && document.documentElement.classList.contains('has-hover')
          ? get(this, 'car.images.hover')
          : get(this, 'car.images.default')
      }
    },
    activated () {
      this.isMouseOver = false
    }
  }
</script>

<style lang="scss">
  $imgHeight: 141px;
  $imgHeightMobile: 110px;

  .car {
    all: unset;
    position: relative;
    display: block;
    padding: 0;
    cursor: pointer;
    background: none;
    border: none;
    outline: none;

    &__image {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: $imgHeight;

      @include object-fit();

      &-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        height: 226px;
        overflow: hidden;

        @include mobile {
          height: 220px;
        }
      }
    }

    &__label {
      display: block;
      width: 100%;
      font-weight: bold;
      color: $c-black;
      text-align: left;
      cursor: pointer;
      border-bottom: 1px solid $c-black;
      transition: all 0.3s;
      margin: {
        bottom: 40px;
      };
      padding: {
        bottom: 7px;
      };

      @include mobile {
        padding: {
          bottom: 8px;
        };
      }

      &_blank {
        margin-bottom: 70px;
      }
    }

    &:focus {
      .car__label {
        color: rgba($c-black, 0.4);
        border-color: rgba($c-black, 0.4);
      }
    }

    @include hover {
      .car__label {
        color: rgba($c-black, 0.4);
        border-color: rgba($c-black, 0.4);
      }
    }
  }
</style>
